export const cleanObject = (obj: object): object =>
  Object.fromEntries(
    Object.entries(obj)
      .filter(
        ([_, value]) =>
          value !== '' &&
          value !== null &&
          value !== undefined &&
          (typeof value !== 'object' ||
            (Array.isArray(value) && value.length > 0) ||
            Object.keys(cleanObject(value)).length > 0),
      )
      .map(([key, value]) => [
        key,
        typeof value === 'object' && !Array.isArray(value)
          ? cleanObject(value)
          : value,
      ]),
  )

export const getEnumOptions = (enumObj: Record<string, string>) =>
  Object.entries(enumObj).map(([key, value]) => ({
    label: value,
    value: key,
  }))
